<template>
	<v-container>
		<v-row class="contentRow">
			<v-row v-if="freeTrial == 0" class="ma-5">
				<v-col cols="12" align="right">
					<v-btn outlined color="trace darken"><a target="_blank" 
						href="https://bookings.cloud.microsoft/book/BookaDemo1@orixe.se/?ismsaljsauthenabled=true" 
						style="text-decoration: none;" class="trace--text text-darken">I need a customized plan!</a></v-btn>
				</v-col>
				<v-col cols="12" align="center">
					<v-btn style="padding: 0 10%;" @click="yourPlan(true)" :color="monthPlan? 'primary' : ''">Monthly</v-btn>
					<v-btn style="padding: 0 10%;" @click="yourPlan(false)" :color="!monthPlan ? 'primary' : ''">
						<span class="d-flex flex-column align-center">
							<span>Yearly</span>
							<span :style="{ fontSize: '80%', color: !monthPlan ? '#ccc' : 'gray' }">Save 16.67%</span>
						</span>
					</v-btn>
				</v-col>
				<v-row class="mt-5">
					<v-col class="flex-grow plan-module ma-2 pd-4 ma-2"
						:style="{ border: allModules.length === 0 ? '2px solid #DE8F18' : '2px solid #1e7c83' }">
						<div class="plan-content">
							<h1 :class="allModules.length === 0 ? 'orange--text' : 'primary--text'">Free</h1>
							<h1 class="mb-5">$0</h1>
							<ul>
								<li>Audit submitting</li>
								<li>Secured with blockchain technology</li>
								<li>Sustainability Assessment of your company</li>
								<li>Calculate your company's CO2 emissions footprint</li>
							</ul>
							<v-btn 
								v-if="allModules.length === 0"
								color="orangeButton" 
								style="color: white;" 
								class="plan-button">
								Your Plan
							</v-btn>
						</div>
					</v-col>
					<v-col class="flex-grow plan-module ma-2"
						:style="{ border: ['Au', 'FTA'].some(plan => allSelectedPlans.includes(plan)) ? '2px solid #DE8F18' : '2px solid #1e7c83' }">
						<div class="plan-content">
							<h1 :class="['Au', 'FTA'].some(plan => allSelectedPlans.includes(plan)) ? 'orange--text' : 'primary--text'">Audit</h1>
                            
							<h1 v-if="allModules.length === 0"><!-- <s style="color: gray;">${{price}}</s> --> $0</h1>
							<p v-if="allModules.length === 0" class="mb-4" style="color: gray;" align="center">For 45 Days</p>
							<h1 v-else-if="monthPlan" class="mb-5">${{price}}</h1>
							<h1 v-else class="mb-5">${{price}}</h1>
							<p>All the features included in <strong>Free</strong> module <strong>and</strong>,</p>
							<ul>
								<li>Full access to the Audit module:
									<ul>
										<li>Create audit templates</li>
									</ul>
									<ul>
										<li>Invite your suppliers to fill out audits</li>
									</ul>
									<ul>
										<li>Flow Down of audits in supply chain</li>
									</ul>
								</li>
							</ul>
							<v-btn 
								v-if="allModules.length === 0" 
								color="primary" 
								class="plan-button" 
								@click="selectPlan('FTA')">
								Get a Free Trial
							</v-btn>
							<v-btn 
								v-if="allSelectedPlans.includes('FTA') && expireData.find(plan => plan.PlanKey === 'FTA' && plan.isExpired === 0)"
								color="orangeButton" 
								class="plan-button">
								Your Trial Plan
							</v-btn>
							<v-btn 
								v-else-if="allSelectedPlans.includes('Au') && expireData.some(plan => plan.PlanKey === 'Au' && plan.isExpired === 0)"
								color="orangeButton" 
								class="plan-button">
								Your Current Plan
							</v-btn>
							<v-btn 
								v-else-if="allModules.length !== 0"
								color="primary" 
								class="plan-button" 
								@click="selectPlan('Au')">
								<!-- {{ expireData.find(plan => plan.PlanKey === 'Au') ? 'Renew Your Plan' : 'Upgrade' }} -->
								Upgrade  
							</v-btn>
						</div>
					</v-col>
					<v-col class="flex-grow plan-module ma-2"
						:style="{ border: ['ESG', 'FTS'].some(plan => allSelectedPlans.includes(plan)) ? '2px solid #DE8F18' : '2px solid #1e7c83' }">
						<div class="plan-content">
							<h1 :class="['ESG', 'FTS'].some(plan => allSelectedPlans.includes(plan)) ? 'orange--text' : 'primary--text'">ESG</h1>

							<h1 v-if="allModules.length === 0"><!-- <s style="color: gray;">${{price}}</s> --> $0</h1>
							<p v-if="allModules.length === 0" class="mb-4" style="color: gray;" align="center">For 45 Days</p>
							<h1 v-else-if="monthPlan" class="mb-5">${{price}}</h1>
							<h1 v-else class="mb-5">${{price}}</h1>
							<p>All the features included in <strong>Free</strong> module <strong>and</strong>,</p>
							<ul>
								<li>Full access to the Sustainability module:
									<ul>
										<li>Sustainability Assessment of your company</li>
									</ul>
									<ul>
										<li>Create risk matrices</li>
									</ul>
									<ul>
										<li>Define risks</li>
									</ul>
									<ul>
										<li>Action plan for mitigation</li>
									</ul>
									<ul>
										<li>Due Diligence year wheel</li>
									</ul>
									<ul>
										<li>PDF reporting</li>
									</ul>
								</li>
							</ul>
							<v-btn 
								v-if="allModules.length === 0" 
								:color="['FTS'].some(plan => allSelectedPlans.includes(plan)) ? 'orangeButton' : 'primary'" 
								class="plan-button" 
								@click="selectPlan('FTS')">
								Get a Free Trial
							</v-btn>
							<v-btn 
								v-if="allSelectedPlans.includes('FTS') && expireData.find(plan => plan.PlanKey === 'FTS' && plan.isExpired === 0)"
								color="orangeButton" 
								class="plan-button">
								Your Trial Plan
							</v-btn>
							<v-btn 
								v-else-if="allSelectedPlans.includes('ESG') && expireData.some(plan => plan.PlanKey === 'ESG' && plan.isExpired === 0)"
								color="orangeButton" 
								class="plan-button">
								Your Current Plan
							</v-btn>
							<v-btn 
								v-else-if="allModules.length !== 0"
								color="primary"
								class="plan-button" 
								@click="selectPlan('ESG')">
								<!-- {{ expireData.find(plan => plan.PlanKey === 'ESG') ? 'Renew Your Plan' : 'Upgrade' }} -->
								Upgrade 
							</v-btn>
						</div>
					</v-col>
					<v-col class="flex-grow plan-module ma-2"
						:style="{ border: ['Pre', 'FTP'].some(plan => allSelectedPlans.includes(plan)) ? '2px solid #DE8F18' : '2px solid #1e7c83' }">
						<div class="plan-content">
							<h1 :class="['Pre', 'FTP'].some(plan => allSelectedPlans.includes(plan)) ? 'orange--text' : 'primary--text'">Premium</h1>

							<h1 v-if="allModules.length === 0"><!-- <s style="color: gray;">${{premiumPrice}}</s> --> $0</h1>
							<p v-if="allModules.length === 0" class="mb-4" style="color: gray;" align="center">For 45 Days</p>
							<h1 v-else-if="monthPlan" class="mb-5">${{premiumPrice}}</h1>
							<h1 v-else class="mb-5">${{premiumPrice}}</h1>
							<ul>
								<li>Full access to the <strong>Audit</strong> including <strong>Audit Flow-Down</strong></li>
								<li>Full access to the <strong>Sustainability</strong> module</li>
								<li>Full access to the <strong>Trace</strong> module - track your components</li>
								<li>Calculate your company's CO2 emissions footprint</li>
								<li>Full access to the orixe.tech platform</li>
							</ul>
							<v-btn 
								v-if="allModules.length === 0" 
								:color="['FTP'].some(plan => allSelectedPlans.includes(plan)) ? 'orangeButton' : 'primary'" 
								class="plan-button" 
								@click="selectPlan('FTP')">
								Get a Free Trial
							</v-btn>
							<v-btn 
								v-if="allSelectedPlans.includes('FTP') && expireData.find(plan => plan.PlanKey === 'FTP' && plan.isExpired === 0)"
								color="orangeButton" 
								class="plan-button">
								Your Trial Plan
							</v-btn>
							<v-btn 
								v-else-if="allSelectedPlans.includes('Pre') && expireData.some(plan => plan.PlanKey === 'Pre' && plan.isExpired === 0)"
								color="orangeButton" 
								class="plan-button">
								Your Current Plan
							</v-btn>
							<v-btn 
								v-else-if="allModules.length !== 0"
								color="primary"
								class="plan-button" 
								@click="selectPlan('Pre')">
								<!-- {{ expireData.find(plan => plan.PlanKey === 'Pre') ? 'Renew Your Plan' : 'Upgrade' }} -->
								Upgrade 
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</v-row>
			<v-row v-else-if="freeTrial == 1" class="contentRow pr-15 pl-15">
				<v-col cols="12" class="pl-15 pr-15">
					<v-card-actions class="justify-end">
						<v-icon class="pl-1 pr-1" color="primary" @click="clickFree()" style="border: 1px solid ;">fas fa-thin fa-times</v-icon>
					</v-card-actions>
					<v-img alt="Success Icon" :src="require('../../assets/twemoji/success.svg')" width="70" class="mx-auto my-8" />
					<h2 class="mb-5">Free Trial!</h2>
					<p>We appreciate your interest in exploring the Orixe platform.</p>
					<p>To help you get started, you have the option to explore our user-friendly platform on your own with assistance from the Orixe Knowledge Page and Tutorial 
						Walkthrough.</p>
					<p>Alternatively, we can schedule an introductory meeting where we'll guide you through the platform, answer any questions, and help you make the most of your 
						free trial.</p>
					<p>Keep an eye on your inbox -- we look forward to supporting you as you discover Orixe!</p>
				</v-col>
			</v-row>
		</v-row>
		<v-dialog v-model="confirm" max-width="600px">
			<v-card>
				<v-card-title class="justify-center"><span class="text-h5 font-weight-bold pt-12">Do you want to purchase this module?</span></v-card-title>
				<v-card-text class="text-center"><span class="black--text">If 'YES', you'll redirect to stripe</span></v-card-text>
				<v-card-actions class="justify-center">
					<v-btn outlined class="ma-2" color="primary" @click="confirm = false">CANCEL</v-btn>
					<v-btn color="orangeButton" dark class="ma-2" @click="moveToStripe()">YES</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="premiumCondition" max-width="600px">
			<v-card>
				<v-card-title class="justify-center"><span class="text-h5 font-weight-bold pt-12">Upgrade to Premium package</span></v-card-title>
				<v-card-text class="text-center"><span class="black--text">You already own the 'Audit' and 'ESG' modules, which are included in the 'Premium'
					package. If you purchase the premium package, you can cancel your existing 'Audit' and 'ESG' subscriptions to avoid duplicate features. Do you
					want to proceed with the upgrade?
				</span></v-card-text>
				<v-card-actions class="justify-center">
					<v-btn outlined class="ma-2" color="primary" @click="premiumCondition = false">CANCEL</v-btn>
					<v-btn color="orangeButton" dark class="ma-2" @click="moveToStripe()">YES</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="registrationOpen" max-width="50%">
			<v-card v-model="valid" class="pa-5">
				<h2 align="center" class="primary--text">Please give your Country and Registration number to see your plans.</h2>
				<v-card-title>Update Company Registration Details</v-card-title>
				<br>
				<v-card-text>
					<v-select
						outlined
						label="Country of Operation"
						v-model="selectedCountry"
						:items="filteredCountries"
						item-text="country"
						:rules="[(v) => !!v || 'Please select a country.']"
						menu-props="{ closeOnClick: false, closeOnContentClick: false }"
					>
						<template v-slot:prepend-item>
							<v-list-item>
								<v-list-item-content>
								<v-text-field
									v-model="searchText"
									label="Search Country"
									clearable
									@click:clear="clearSearch"
									@input="filterCountries"
								></v-text-field>
								</v-list-item-content>
							</v-list-item>
						</template>
					</v-select>
					<v-text-field
						outlined
						label="Company registration number (between 4-25 characters)"
						v-model="companyRegistrationNumber"
						name="companyregistration"
						append-icon="fas fa-address-card"
						type="text"
						:rules="[(v)=>{return !!v || 'This field is required.'},
							v => (v && v.length >= 4 && v.length <= 25) || 'Company registration number must be between 4 and 25 characters' 
						]"
					></v-text-field>
					<p>Please use the following link as an example to your country's company registration number 
						<b><a href="/Company_Registration_Number_Format.pdf" target="_blank">Company Registration Number Format</a></b>
					</p>
				</v-card-text>
				<v-card-actions class="ml-4">
					<v-btn color="primary" text :disabled="!isFormValid" type="submit" @click="updateregistrationDetails(selectedCountry, companyRegistrationNumber)" outlined
						>Update</v-btn
					>
					<v-btn color="error" text @click="clickFree()" outlined
						>Cancel</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>

import LoadingState from "../../consts/LoadingState"
import UpgradePackageAPI from "../../api/billing"
import CompanyregAPI from "../../api/clients/registration" 
export default {
	name: "UpgradePlans",
	components: {
		
	},
	data() {
		return {
			freeTrial: 0,
			hasTriedFreeTrial: false,
			monthPlan: true,
			selectedPlan: "F",
			price: null,
			tryFreeTrial: false,
			premiumPrice: null,
			priceCategory: null,
			allSelectedPlans: [],
			allModules: [],
			expireData: [],
			confirm: false, 
			premiumCondition: false,
			valid: false,
			registrationOpen: false,
			selectedCountry: null,
			countries: [
				{ country: "Afghanistan" }, { country: "Albania" }, { country: "Algeria" }, { country: "Andorra" }, { country: "Angola" }, { country: "Antigua and Barbuda" }, 
				{ country: "Argentina" }, { country: "Armenia" }, { country: "Australia" }, { country: "Austria" }, { country: "Azerbaijan" },
				{ country: "Bahamas" }, { country: "Bahrain" }, { country: "Bangladesh" }, { country: "Barbados" }, { country: "Belarus" }, { country: "Belgium" }, 
				{ country: "Belize" }, { country: "Benin" }, { country: "Bhutan" }, { country: "Bolivia" }, { country: "Bosnia and Herzegovina" }, { country: "Botswana" },
				{ country: "Brazil" }, { country: "Brunei" }, { country: "Bulgaria" }, { country: "Burkina Faso" }, { country: "Burundi" }, 
				{ country: "Cambodia" }, { country: "Cameroon" }, { country: "Canada" }, { country: "Cape Verde" }, { country: "Cayman Islands" }, { country: "	Central African Republic" },
				{ country: "Chad" }, { country: "Chile" }, { country: "China" }, { country: "Christmas Island" }, { country: "Cocos (Keeling) Islands" }, { country: "Colombia" },
				{ country: "Comoros" }, { country: "Democratic Republic of the Congo" }, { country: "Congo, Republic of (Brazzaville)" }, { country: "	Cook Islands" },
				{ country: "Costa Rica" }, { country: "Côte D'ivoire (Ivory Coast)" }, { country: "Croatia" }, { country: "Cuba" }, { country: "Cyprus" }, { country: "	Czech Republic" },
				{ country: "Denmark" }, { country: "Djibouti" }, { country: "Dominica" }, { country: "Dominican Republic" },
				{ country: "East Timor (Timor-Leste)" }, { country: "Ecuador" }, { country: "Egypt" }, { country: "El Salvador" }, { country: "Equatorial Guinea" }, { country: "Eritrea" },
				{ country: "Estonia" }, { country: "Ethiopia" }, 
				{ country: "Falkland Islands" }, { country: "Faroe Islands" }, { country: "Fiji" }, { country: "Finland" }, { country: "France" }, { country: "French Guiana" },
				{ country: "French Polynesia" }, { country: "French Southern Territories" },
				{ country: "Gabon" }, { country: "The Gambia" }, { country: "Georgia" }, { country: "Germany" }, { country: "Ghana" }, { country: "Gibraltar" },
				{ country: "Greece" }, { country: "Greenland" }, { country: "Grenada" }, { country: "Guadeloupe" }, { country: "Guam" }, { country: "Guatemala" },
				{ country: "Guinea" }, { country: "Guinea-Bissau" }, { country: "Guyana" },
				{ country: "Haiti" }, { country: "Holy See" }, { country: "Honduras" }, { country: "Hong Kong" }, { country: "Hungary" },
				{ country: "Iceland" }, { country: "India" }, { country: "Indonesia" }, { country: "Iran" }, { country: "Iraq" }, { country: "Ireland" },
				{ country: "Israel" }, { country: "Italy" }, { country: "Ivory Coast" },
				{ country: "Jamaica" }, { country: "Japan" }, { country: "Jordan" }, 
				{ country: "Kazakhstan" }, { country: "Kenya" }, { country: "Kiribati" }, { country: "Korea, Democratic People's Rep. (North Korea)" }, { country: "Korea, Republic of (South Korea)" }, 
				{ country: "Kosovo" }, { country: "Kuwait" }, { country: "Kyrgyzstan" },
				{ country: "Laos" }, { country: "Latvia" }, { country: "Lebanon" }, { country: "Lesotho" }, { country: "Liberia" }, { country: "Libya" },
				{ country: "Liechtenstein" }, { country: "Lithuania" }, { country: "Luxembourg" },
				{ country: "Macau" }, { country: "Madagascar" }, { country: "Malawi" }, { country: "Malaysia" }, { country: "Maldives" }, { country: "Mali" },
				{ country: "Malta" }, { country: "Marshall Islands" }, { country: "Martinique" }, { country: "Mauritania" }, { country: "Mauritius" }, { country: "Mayotte" },
				{ country: "Mexico" }, { country: "Micronesia" }, { country: "Moldova" }, { country: "Monaco" }, { country: "Mongolia" }, { country: "Montenegro" },
				{ country: "Montserrat" }, { country: "Morocco" }, { country: "Mozambique" }, { country: "Myanmar" }, 
				{ country: "Namibia" }, { country: "Nauru" }, { country: "Nepal" }, { country: "Netherlands" }, { country: "Netherlands Antilles" }, { country: "New Caledonia" },
				{ country: "New Zealand" }, { country: "Nicaragua" }, { country: "Niger" }, { country: "Nigeria" }, { country: "Niue" }, { country: "North Macedonia" },
				{ country: "Northern Mariana Islands" }, { country: "Norway" }, 
				{ country: "Oman" }, 
				{ country: "Pakistan" }, { country: "Palau" }, { country: "Palestine" }, { country: "Panama" }, { country: "Papua New Guinea" }, { country: "Paraguay" },
				{ country: "Peru" }, { country: "Philippines" }, { country: "Pitcairn Island" }, { country: "Poland" }, { country: "Portugal" }, { country: "Puerto Rico" },
				{ country: "Qatar" }, 
				{ country: "Reunion Island" }, { country: "Romania" }, { country: "Russian Federation" }, { country: "Rwanda" }, 
				{ country: "Saint Kitts and Nevis" }, { country: "Saint Lucia" }, { country: "Saint Vincent and the Grenadines" }, { country: "Samoa" },
				{ country: "San Marino" }, { country: "Sao Tome and Principe" }, { country: "Saudi Arabia" }, { country: "Senegal" }, { country: "Serbia" }, { country: "Seychelles" },
				{ country: "Sierra Leone" }, { country: "Singapore" }, { country: "Slovakia" }, { country: "Slovenia" }, { country: "Solomon Islands" }, { country: "Somalia" },
				{ country: "South Africa" }, { country: "South Sudan" }, { country: "Spain" }, { country: "Sri Lanka" }, { country: "Sudan" }, { country: "Suriname" },
				{ country: "Swaziland" }, { country: "Sweden" }, { country: "Switzerland" }, { country: "Syria" },
				{ country: "Taiwan" }, { country: "Tajikistan" }, { country: "Tanzania" }, { country: "Thailand" }, { country: "Tibet" }, { country: "Timor-Leste" },
				{ country: "Togo" }, { country: "Tokelau" }, { country: "Tonga" }, { country: "Trinidad and Tobago" }, { country: "Tunisia" }, { country: "Turkey" },
				{ country: "Turkmenistan" }, { country: "Turks and Caicos Islands" }, { country: "Tuvalu" }, 
				{ country: "Uganda" }, { country: "Ukraine" }, { country: "United Arab Emirates" }, { country: "United Kingdom" }, { country: "United States" },
				{ country: "Uruguay" }, { country: "Uzbekistan" }, 
				{ country: "Vanuatu" }, { country: "Vatican City State" }, { country: "Venezuela" }, { country: "Vietnam" },
				{ country: "Virgin Islands (British)" }, { country: "Virgin Islands (U.S.)" },
				{ country: "Wallis and Futuna Islands" }, { country: "Western Sahara" },
				{ country: "Yemen" },
				{ country: "Zambia" }, { country: "Zimbabwe" },
			],
			searchText: "",
			companyRegistrationNumber: "",
		}
	},
	mounted() {
		//this.getPriceCategoryData()
		this.getMonthlyPackageData()
		this.getRegistrationDetails()
			.then(() => {
				if (!this.selectedCountry || !this.companyRegistrationNumber) {
					this.registrationOpen = true
				} else {
					this.registrationOpen = false
				}
			})
	},
	computed: {
		filteredCountries() {
			const searchTerm = this.searchText.toLowerCase().trim()
			if (!searchTerm) {
				return [...this.countries]
			} else {
				return this.countries.filter(
					(country) =>
						country.country.toLowerCase().includes(searchTerm)
				)
			}
		},
		isFormValid() {
			return (
				this.selectedCountry && this.companyRegistrationNumber
			)
		}
	},
	methods: {
		clearSearch() {
			this.searchText = ""
			this.filterCountries()
		},
		selectPlan(plan) {
			this.selectedPlan = plan
			if(this.selectedPlan === "FTA" || this.selectedPlan === "FTS" || this.selectedPlan === "FTP"){
				this.getFreeTrial()
				this.savePackageData()
			}else if(this.selectedPlan === "Pre"){
				const hasAuPackage = this.expireData.some(entry => (entry.PlanKey === "Au" || entry.PlanKey === "FTA") && entry.isExpired === 0)
				const hasESGPackage = this.expireData.some(entry => (entry.PlanKey === "ESG" || entry.PlanKey === "FTS") && entry.isExpired === 0)
	
				if (hasAuPackage && hasESGPackage) {
					this.premiumCondition = true
				} else {
					this.confirm = true
				}
			}else{
				this.confirm = true
			}
		},
		moveToStripe(){
			this.savePackageData()
			/* window.open("https://stripe.com/", "_blank") */
			this.confirm = false
			/* location.reload() */
		},
		getFreeTrial(){
			this.freeTrial = 1,
			this.hasTriedFreeTrial = true
		},

		//after select monthly plan
		getMonthlyPackageData(){
			UpgradePackageAPI.getUpgradePackages()
				.then(result => {
					this.allSelectedPlans = result.packages
						.filter(entry => entry.MonthYear === 0)
						.map(entry => entry.PlanKey)
			
					this.allModules = result.packages
						.map(entry => entry.PlanKey)
						.filter(planKey => planKey)

					this.priceCategory = result.priceCategory
	
					this.expireData = result.packages
						.filter(entry => entry.MonthYear === 0)
						.map(entry => ({
							PlanKey: entry.PlanKey,
							isExpired: entry.isExpired
						}))
					//price list for Audit and ESG
					if(this.allSelectedPlans !== "F"){
						if (this.priceCategory === 0 ) {
							this.price = 80
							this.premiumPrice = 120
						}else if (this.priceCategory === 1 ){
							this.price = 160
							this.premiumPrice = 240
						}
					}
				})
				.catch(error => {
					console.error("Error checking free trials:", error)
				})
		},

		//after select yearly plan
		getYearlyPackageData(){
			UpgradePackageAPI.getUpgradePackages()
				.then(result => {
					this.allSelectedPlans = result.packages
						.filter(entry => entry.MonthYear === 1)
						.map(entry => entry.PlanKey)
					
					this.allModules = result.packages
						.map(entry => entry.PlanKey)
						.filter(planKey => planKey)

					this.priceCategory = result.priceCategory

					this.expireData = result.packages
						.filter(entry => entry.MonthYear === 1)
						.map(entry => ({
							PlanKey: entry.PlanKey,
							isExpired: entry.isExpired
						}))

					//price list for Audit and ESG
					if(this.allSelectedPlans !== "F"){
						if (this.priceCategory === 0 ){
							this.price = 800
							this.premiumPrice = 1200
						}else if (this.priceCategory === 1 ){
							this.price = 1600
							this.premiumPrice = 2400
						}
					}
				})
				.catch(error => {
					console.error("Error checking free trials:", error)
				})
		},
		savePackageData(){
			let currentPlan = this.monthPlan === true ? 0 : 1
			
			let submitTime = new Date()
			let SubmittedDate = submitTime.toISOString().slice(0, 19).replace("T", " ")

			if(this.selectedPlan === "FTA" || this.selectedPlan === "FTS" || this.selectedPlan === "FTP"){
				submitTime.setDate(submitTime.getDate() + 45)
			}else if((this.selectedPlan === "Au" || this.selectedPlan === "ESG" || this.selectedPlan === "Pre") && currentPlan === 0){
				submitTime.setDate(submitTime.getDate() + 30)
			}else if((this.selectedPlan === "Au" || this.selectedPlan === "ESG" || this.selectedPlan === "Pre") && currentPlan === 1){
				submitTime.setDate(submitTime.getDate() + 365)
			}
			
			let expireDate = submitTime.toISOString().slice(0, 19).replace("T", " ")
			
			let payment
			if(this.selectedPlan === "FTA" || this.selectedPlan === "FTS" || this.selectedPlan === "FTP"){
				payment = 0
			}else if(this.selectedPlan === "Au" && currentPlan === 0){
				payment = 1
			}else if(this.selectedPlan === "ESG" && currentPlan === 0){
				payment = 2
			}else if(this.selectedPlan === "Pre" && currentPlan === 0){
				payment = 3
			}else if(this.selectedPlan === "Au" && currentPlan === 1){
				payment = 4
			}else if(this.selectedPlan === "ESG" && currentPlan === 1){
				payment = 5
			}else if(this.selectedPlan === "Pre" && currentPlan === 1){
				payment = 6
			}
			
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			UpgradePackageAPI.upgradePackages(currentPlan, payment, SubmittedDate, expireDate, this.selectedPlan)
				.then( data => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						`Successfully get the free trial`,
						{ root: true }
					)
					console.log("link",data)
					if (data.url && (this.selectedPlan === "Au" || this.selectedPlan === "ESG" || this.selectedPlan === "Pre")) {
						window.location.href = data.url
					}
					
				})
				.catch(error => {
					this.error = error
					console.error("Error checking free trials:", error)
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		clickFree(){
			this.$router.push("/")
		},
		yourPlan(plan){
			this.monthPlan = plan
			//this.getPriceCategoryData()
			if(this.monthPlan){
				this.getMonthlyPackageData()
			}else{
				this.getYearlyPackageData()
			}
		},
		updateregistrationDetails(selectedCountry, companyRegistrationNumber){
			this.registrationOpen = false
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			CompanyregAPI.updateRegistration(selectedCountry, companyRegistrationNumber)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						"Sucessfully Updated Action!",
						{ root: true }
					)
					this.getPriceCategoryData()
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		getRegistrationDetails() {
			CompanyregAPI.getRegistration()
				.then(data => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
					this.companyRegistrationNumber = data[0].number
					this.selectedCountry = data[0].country
					
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
	}
}
</script>

<style>
.plan-module {
	border-radius: 20px;
	transition: border 0.3s ease;
	min-height: 300px;
	display: flex;
	flex-direction: column;
}

.plan-content {
	display: flex;
	flex-direction: column;
	height: 100%;
	padding: 5px;
}

.plan-button {
	width: 80%;
	margin: 0 auto !important;
	margin-top: auto !important;
}
</style>